import {RoundEvent} from './RoundEvent';

export class RoundUpdated extends RoundEvent {}
